import Fluxxor from 'fluxxor';

import constants from 'ofs/apps/core/constants';
import {preventDefault} from 'ofs/apps/core/utils/Event';


const ScrollStore = Fluxxor.createStore({
  initialize: function() {
    this.bindActions(
      constants.DISABLE_SCROLL, this.disable,
      constants.ENABLE_SCROLL, this.enable,
      constants.SCROLL_TO, this.to,
    );
  },

  disable: function() {
    document.body.style['padding-bottom'] = '60px';
    document.body.style.overflow = 'hidden';
    window.ontouchmove = preventDefault;
    this.emit('change');
  },

  enable: function() {
    document.body.style['padding-bottom'] = '';
    document.body.style.overflow = '';
    window.ontouchmove = undefined;
    this.emit('change');
  },

  to: function(payload) {
    window.scrollTo(payload.x, payload.y);
  }

});

export default ScrollStore;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/stores/scroll.js
 **/